/**
 * i18n preload — pre-bundles critical translation namespaces
 * so they are available immediately on first render without HTTP fetch.
 *
 * With partialBundledLanguages: true, preloaded namespaces are NOT re-fetched
 * via the HTTP backend. Single source of truth: public/locales/.
 */
import type { Resource } from "i18next";
import arCommon from "../public/locales/ar/common.json";
import enCommon from "../public/locales/en/common.json";
import arAdmin from "../public/locales/ar/admin.json";
import enAdmin from "../public/locales/en/admin.json";

const preloadedResources: Resource = {
  ar: { common: arCommon, admin: arAdmin },
  en: { common: enCommon, admin: enAdmin },
};

export { preloadedResources };
